import { Attrs, MinzeElement } from 'minze'

export interface LvcEventDraftIcon {
  width?: number
  height?: number
}

export class LvcEventDraftIcon extends MinzeElement {
  attrs: Attrs = [
    ['width', 30],
    ['height', 30],
  ]
  html = () => `
    <svg xmlns="http://www.w3.org/2000/svg" width="${this.width}" height="${this.height}" viewBox="0 0 42 42" fill="none">
<path d="M4.81641 7.99502L34.2686 8.42617M34.6121 8.29732C35.2078 10.4167 35.7288 12.865 35.746 15.0664C35.746 15.1202 35.7349 15.1729 35.714 15.2214C35.7104 15.32 35.6697 15.4139 35.5996 15.4839C35.5263 15.5573 35.4267 15.5985 35.323 15.5985L5.02547 15.3481C4.92171 15.3481 4.82219 15.3069 4.74882 15.2335C4.69417 15.1789 4.65735 15.1097 4.64213 15.0351C4.62709 14.9937 4.6187 14.9468 4.6187 14.8944C4.6813 12.7817 4.6252 10.3479 4.5 8.23526M27.6626 16.8554C27.9658 14.4373 27.867 9.1272 27.6626 6.27489M11.581 6.00007L11.9073 16.7696M34.5062 35.5525L5.53394 34.8495C5.48728 34.8686 5.43693 34.8788 5.38553 34.8788C5.28177 34.8788 5.18226 34.8375 5.10889 34.7642C5.03552 34.6908 4.9943 34.5913 4.9943 34.4875C5.20296 29.4275 5.20671 23.9463 4.99805 18.8759M34.2434 35.1961C34.2481 29.7891 34.4365 24.1044 34.8536 18.7284C34.8536 18.41 34.5741 18.2939 34.3487 18.369C24.757 18.546 14.7726 18.6051 5.19141 18.5009" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  `

  css = () => `
    :host {
      width: ${this.width ?? '28'}px;
      height: ${this.height ?? '28'}px;
    }
  `
}
